import { AsyncPipe, CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table'
import { NgxPaginationModule } from 'ngx-pagination'
import { catchError, map, Observable, switchMap, tap } from 'rxjs'
import { Outsider } from '../../models/outsider.interface'
import { LayoutService } from '../../services/layout/layout.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Filter, QueryGet } from '../../shared/query-types'
import { OutsiderService } from '../../services/outsider/outsider.service'
import { PAGINATION } from '../../shared/constants'
import { SearchComponent } from '../../components/search/search.component'
import { Pagination } from '../../models/pagination.interface'
import { ToastrService } from 'ngx-toastr'
import { OutsiderFormComponent } from '../outsider-form/outsider-form.component'
import { MatDialog } from '@angular/material/dialog'
import { MatSidenavModule } from '@angular/material/sidenav'
import { LoadingService } from '../../services/loadingService/loading.service'
import { OnlysuperuserDirective } from '../../directives/onlysuperuser.directive'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'app-list-outsider',
    standalone: true,
    imports: [
        CommonModule,
        MatIcon,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        NgxPaginationModule,
        AsyncPipe,
        SearchComponent,
        MatSidenavModule,
        OnlysuperuserDirective,
    ],
    templateUrl: './outsider-list.component.html',
    styleUrl: './outsider-list.component.css',
})
export class ListOutsiderComponent {
    public page: number | undefined
    @Input() filtro: string = ''
    @Input() orden: string = ''
    limit = 10
    total = 0
    outsiderList: Outsider[] = []
    selectedOutsider: Outsider | null = null
    asyncOutsider!: Observable<Pagination<Outsider[]>>
    showColumns: string[] = [
        'acciones',
        'identificationCode',
        'identificationType',
        'name',
        'lastName',
        'birthDate',
        'email',
        'phone',
        'sex',
        'location',
        'placeBirth',
    ]

    constructor(
        private layoutService: LayoutService,
        private activatedRouter: ActivatedRoute,
        private outsiderService: OutsiderService,
        private router: Router,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private loadingService: LoadingService,
        private title: Title
    ) {this.title.setTitle('Persona')}

    fetchOutsider(page: number, filter: Filter | null = null, search = '') {
        const offset = page > 1 ? page * this.limit - this.limit : 0
        const params: QueryGet = {
            order: '-id',
            limit: this.limit,
            offset,
            search,
            filters: [],
        }
        if (filter) {
            params.filters.push(filter)
        }
        this.page = page
        this.loadingService.show(true)
        this.asyncOutsider = this.outsiderService.allOutsiders(params).pipe(
            tap((response) => {
                this.outsiderList = response.results
                this.outsiderService.setOutsiders(response.results)
                this.total = response.count
            }),
            map((res) => {
                this.loadingService.show(false)
                return res
            }),
            catchError((error) => {
                this.loadingService.show(false)
                this.router.navigate(['home/'])
                return []
            })
        )
    }

    ngOnInit(): void {
        this.layoutService.paginationLimit$
            .pipe(
                switchMap((limit) => {
                    this.limit = limit
                    return this.activatedRouter.queryParamMap
                }),
                switchMap((params) => {
                    const pageNum = params.get('page') || '1'
                    const search = params.get('search') || ''
                    this.page = parseInt(pageNum)
                    this.fetchOutsider(PAGINATION.first_page, null, search)
                    return this.layoutService.paginationLimit$
                })
            )
            .subscribe()
    }

    eliminate(outsider: Outsider): void {
        const confirmed = window.confirm(
            `¿Estás seguro de eliminar a: ${outsider.identificationCode} ${outsider.name} ${outsider.lastName}?`
        )
        if (!confirmed) return
        this.outsiderService.deleteOutsider(outsider.id).subscribe({
            next: () => {
                const successMsg = `Eliminado CORRECTAMENTE!`
                this.toastr.success(successMsg, 'Exitoso!', {
                    progressBar: true,
                    timeOut: 5000,
                })
                this.fetchOutsider(PAGINATION.first_page)
            },
            error: (err) => {
                this.toastr.error('No se pudo eliminar', 'Error')
            },
        })
    }

    updateOutsider(outsider: Outsider) {
        this.outsiderService.setOutsider(outsider)
        const dialogRef = this.dialog.open(OutsiderFormComponent, {
            data: { selectedOutsider: this.selectedOutsider },
            width: '90vw',
            maxWidth: '80vw',
            maxHeight: '80vh',
        })
        dialogRef.afterClosed().subscribe(() => {
            this.fetchOutsider(PAGINATION.first_page)
        })
    }
    create(): void {}
}
